import React, { useCallback, useEffect, useState } from 'react';
import styled from 'styled-components';
import MemberIdIcon from '../../assets/icons/vectors/MemberID.svg';
import MemberName from '../../assets/icons/vectors/MemberName.svg';
import Mobile from '../../assets/icons/vectors/Mobile.svg';
import Email from '../../assets/icons/vectors/EmailID.svg';
import City from '../../assets/icons/vectors/City.svg';
import Address from '../../assets/icons/vectors/Address.svg';
// import UserImage from '../../assets/icons/User_Image.svg';
import { useDispatch, useSelector } from 'react-redux';
import { SERVICES } from '../Services';
import fetchData from '../FetchData';
import { Tooltip } from '@mui/material';
import { get } from '../ApiHandler/apihandler';
import Loader from '../Loader/Loader';

const UserContainer = styled.div`
  display: flex;
  background: rgba(192, 238, 228, 0.5);
  width: 80%;
  margin: 30px auto;
  border-radius: 20px;
  @media (max-width: 767px) {
    width: 95%;
    flex-direction: column-reverse;
  }
`;

const LeftContainer = styled.div`
  display: flex;
  align-items: center;
  // justify-content: center;
  flex: 1;
  padding: 24px;
  padding-left: 0px;
  margin-left: 15px;
  width: 80%;
  @media (max-width: 767px) {
    margin-bottom: 15px;
    width: auto;
    // justify-content: center;
    padding: 0px 15px;
    margin-left: 0;
  }
`;

const UserInfoTable = styled.table`
  border-collapse: collapse;
  padding: 15px;
  background: #fff;
  border-radius: 20px;
  padding: 10px;
  border-collapse: separate;
  width: 100%;
  table-layout: fixed;
  @media (max-width: 767px) {
    width: 100%;
  }
`;

const TableRow = styled.tr`
  display: flex;
  align-items: center;
  border-bottom: 1px solid #dff6f1;
  &:last-child {
    border-bottom: none;
  }
`;

const TableCell = styled.td`
  width: 135px;
  padding: 5px;
  font-family: 'Noto Sans';
  font-style: normal;
  font-weight: 600;
  font-size: 15px;
  line-height: 22px;
  color: #505050;
  align-items: center;
  display: flex;
  @media (max-width: 767px) {
    padding: 5px;
    font-size: 14px;
    width: 100px;
  }
`;

const Icon = styled.img`
  width: 20px;
  height: 22px;
  @media (max-width: 767px) {
    width: 20px;
    height: 20px;
  }
`;

const UserText = styled.td`
  font-family: 'Noto Sans';
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 25px;
  color: #006a61;
  margin-left: 0px;
  width: 635px;
  overflow: hidden;
  white-space: normal;
  text-overflow: ellipsis;
  flex: 1;
  border-left: 2px solid #dff6f1;
  padding-left: 15px;
  @media (max-width: 767px) {
    font-size: 14px;
    margin-left: 10px;
    max-width: unset;
    // width: 200px;
    white-space: normal;
    word-wrap: break-word;
    line-height: normal;
  }
`;
const RightContainer = styled.div`
  margin-top: 0px;
  display: flex;
  justify-content: center;
  align-items: center;
  padding-right: 25px;
  width: 20%;
  // margin-left: 120px;
  // flex: 1;
  @media (max-width: 767px) {
    width: 100%;
    margin-left: 0;
    margin-left: 0;
    margin-top: 0;
    margin-bottom: 30px;
    padding: 0px;
  }
`;

const Ellipse = styled.div`
  position: relative;
  width: 150px;
  height: 150px;
  background: white;
  border-radius: 50%;
  @media (max-width: 767px) {
    width: 100px;
    height: 100px;
    margin-top: 20px;
  }
`;

const UserImageContainer = styled.div`
  position: absolute;
  width: 150px;
  height: 150px;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  border-radius: 50%;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  @media (max-width: 767px) {
    width: 120px;
    height: 120px;
  }
`;

const Image = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  max-width: 100%;
  @media (max-width: 767px) {
    max-width: 100%;
  }
`;
const Initials = styled.div`
  font-size: 80px;
  @media (max-width: 767px) {
    font-size: 40px;
  }
`;
const UserDetails = () => {
  const memberId = useSelector((state) => state.member.memberId);
  const dispatch = useDispatch();
  const [userData, setUserData] = useState({});
  const [profileData, setProfileData] = useState({});
  const [isMobile, setIsMobile] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const getInitials = (name) => {
    if (typeof name !== 'string') {
      return '';
    }

    const initials = name
      .split(' ')
      .map((word) => word.charAt(0))
      .join('')
      .toUpperCase();

    return initials;
  };

  const fetchUserData = useCallback(async () => {
    const url = SERVICES.MEMBER_DETAILS(memberId);
    await fetchData(url, setUserData, dispatch, setIsLoading);
  }, [memberId, dispatch]);
  useEffect(() => {
    fetchUserData();
  }, [fetchUserData]);
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 767);
    };

    handleResize();

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);
  const getUserRole = async () => {
    try {
      const url = `${SERVICES.GET_PROFILE}`;
      const response = await get(url);
      if (response && response.ok) {
        const data = await response.json();
        setProfileData(data.data);
      }
    } catch (error) {
      console.error('Error:', error);
    }
  };
  useEffect(() => {
    getUserRole();
  }, []);
  const tableRows = [
    { iconSrc: MemberIdIcon, label: 'Member Id', value: userData.id },
    { iconSrc: MemberName, label: 'Member Name', value: userData.fullName },
    { iconSrc: Mobile, label: 'Mobile', value: userData.mobileNumber },
    { iconSrc: Email, label: 'Email ID', value: userData.emailId },
    {
      iconSrc: Address,
      label: 'Address',
      value: userData.addressLine1,
    },
    { iconSrc: City, label: 'City', value: userData.cityName },
  ];
  return (
    <>
      <UserContainer>
        <LeftContainer>
          <UserInfoTable>
            <tbody>
              {tableRows.map((row, index) => (
                <TableRow key={index}>
                  <TableCell style={{ width: '20px' }}>
                    <Icon src={row.iconSrc} alt="/icon" />
                  </TableCell>
                  {!isMobile && <TableCell>{row.label}</TableCell>}
                  {/* <TableCell>
                  <UserText>{row.value}</UserText>
                </TableCell> */}
                  <Tooltip title={row.value} placement="top-start">
                    <UserText>{row.value}</UserText>
                  </Tooltip>
                  {/* <UserText>{row.value}</UserText> */}
                </TableRow>
              ))}
            </tbody>
          </UserInfoTable>
        </LeftContainer>
        <RightContainer>
          <Ellipse>
            <UserImageContainer>
              {profileData.profilePhotoUrl !== null ? (
                <Image src={profileData?.profilePhotoUrl} alt="User Image" />
              ) : (
                <Initials>{getInitials(profileData?.fullName)}</Initials>
              )}
              {/* <Image src={profileData?.profilePhotoUrl} alt="User Image" /> */}
            </UserImageContainer>
          </Ellipse>
        </RightContainer>
      </UserContainer>
      {isLoading && <Loader />}
    </>
  );
};
export default UserDetails;
